import React, { FC, Suspense } from 'react'
import Box from '@mui/material/Box'
import { CircularProgress } from '@mui/material'
import AppContextModal from '@app/components/AppModal/AppContextModal'
import { AppIcon } from '@app/components/AppIcon'

const AddNewModule = React.lazy(
	() =>
		import(
			/* webpackChunkName: "add_new_edu_module_form" */ './AddNewModule'
		)
)

interface AddNewModuleModalProps {
	action: 'New' | 'Edit'
	_id?: String,
    closePopover?: () => void,
	disabled?: boolean
}

const AddNewModuleModal: FC<AddNewModuleModalProps> = ({
	action,
	_id,
    closePopover,
   	disabled
}: AddNewModuleModalProps) => {
    return (
		<AppContextModal
			title={action === 'Edit' ? 'Edit module' : 'Add new module'}
			startIcon={action === 'Edit' ? <AppIcon type={'edit'} /> : null}
			openModalButtonText={action === 'Edit' ? 'Edit' : '+ New'}
			buttonVariant='text'
			buttonColor='primary'
			openButtonSx={{
				fontSize: action === 'Edit' ? '0.9375rem' : '1.05rem',
				fontWeight: action === 'Edit' ? 400 : 600,
				px: 4.5,
			}}
			openButtonDisabled={disabled}
		>
			<Suspense
				fallback={
					<Box
						display={'flex'}
						alignItems={'center'}
						justifyContent={'center'}
						my={'auto'}
						py={50}
					>
						<CircularProgress />
					</Box>
				}
			>
				<AddNewModule action={action} _id={_id} closePopover={closePopover}/>
			</Suspense>
		</AppContextModal>
	)
}

export default AddNewModuleModal
